enum SalutationsEnum {
  MR = 'MR',
  MRS = 'MRS',
}

export default SalutationsEnum;
